import * as PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import Popconfirm from 'antd/lib/popconfirm';
import { QuestionCircleTwoTone, DeleteOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const DeleteButton = ({ pending, handleDelete, size, className }) => (
    <Popconfirm
        placement="left"
        title={<FormattedMessage id="alert.delete.info" />}
        icon={<QuestionCircleTwoTone twoToneColor="red" />}
        onConfirm={() => {
            handleDelete();
        }}
        okText={<FormattedMessage id="alert.delete.yes" />}
        cancelText={<FormattedMessage id="alert.delete.no" />}
    >
        <Button className={className} loading={pending} size={size} type="danger" icon={<DeleteOutlined />} />
    </Popconfirm>
);

DeleteButton.sizes = {
    default: 'default',
    small: 'small',
    large: 'large',
};

DeleteButton.propTypes = {
    pending: PropTypes.bool,
    handleDelete: PropTypes.func.isRequired,
    size: PropTypes.oneOf(Object.values(DeleteButton.sizes)),
    className: PropTypes.string,
};

DeleteButton.defaultProps = {
    pending: false,
    size: DeleteButton.sizes.default,
    className: null,
};

export default DeleteButton;
